import React from 'react';
import NavigationMenuSection from "../../../menu-items/section/section";
import NavigationMenuItemUrl from "../../../menu-items/menu-item-url";
import NavigationSection from "../../../../../core/model2/navigation/navigation-section";

type Props = {
    onToggle            : (a: string, b: boolean)=>void
    isManager?          : boolean
    collapseState       : any,
    navigationSection   : NavigationSection
}

export default function MenuSettingsIntegrations(props: Props) {

    const onToggle = (isOpen: boolean) => {
        props.onToggle('integrations', isOpen)
    };

    return (
        <NavigationMenuSection
            name="Integrations" collapsible={true}
            onToggle={onToggle}
            counter={2}
            // isOpen={!gd.user.menu.collapsedSettings.includes('integrations')}
            isOpen={!props.collapseState.isCollapsed('integrations')}
        >
            <NavigationMenuItemUrl name="Integrations" icon="i5-integration" url={'settings/integrations'} navigationSection={props.navigationSection}/>
            <NavigationMenuItemUrl name="API" icon="i5-api" url={'settings/api-v2'}  navigationSection={props.navigationSection}/>
        </NavigationMenuSection>
    )

}
